/**
 * Created by noahguld on 27/06/2017.
 */
export const HOSPITAL = 'HOSPITAL';
export const LABORATORY = 'LABORATORY';
export const OTHERS = 'OTHERS';
export const PHARMACY = 'PHARMACY';
export const RADIOLOGY = 'RADIOLOGY';
export const URGENT_CARE = 'URGENT_CARE';
